/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const SimilarCompanyType = zod.enum(["LEAD", "CLIENT"]);

export type SimilarCompanyType = zod.input<typeof SimilarCompanyType>;
export type SimilarCompanyTypeOutput = zod.output<typeof SimilarCompanyType>;
